import {
  AppBar,
  Box,
  Button,
  Container,
  Toolbar,
  Typography,
} from "@mui/material";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Images from "../../assets";
import { useAppSelector } from "../../assets/hooks";
import { logOut } from "../../assets/library";
import Search from "./search";
import { FilterProps } from "../../types/types";
import { globalButton } from "../styles/customStyles";

const Header = (props: FilterProps) => {
  const location = useLocation();
  const navigate = useNavigate();
  const profile = useAppSelector((state) => state.profileInfo);
  // eslint-disable-next-line
  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null);
  const activeExploreTab = React.useMemo<"courses" | "universities" | null>(() => {
      if (location.pathname !== "/explore") return null;
      const encodedUrl = location.search.slice(1);
      if (!encodedUrl) return "courses";
      try {
        const decodedUrl = window.atob(encodedUrl);
        const searchParams = new URLSearchParams(decodedUrl);
        const rawActiveTab = searchParams.get("activeTab");
        const tab = rawActiveTab ? JSON.parse(rawActiveTab) : "courses";
        return tab === "universities" ? "universities" : "courses";
      } catch {
        return "courses";
      }
    }, [location.pathname, location.search]);

  const handleExploreListToggle = React.useCallback(() => {
      if (location.pathname !== "/explore") return;
      const targetTab = activeExploreTab === "courses" ? "universities" : "courses";
      const encodedUrl = location.search.slice(1);
      //let filterData = "[]";
      let search = JSON.stringify("");
      try {
        if (encodedUrl) {
          const decodedUrl = window.atob(encodedUrl);
          const searchParams = new URLSearchParams(decodedUrl);
          //filterData = searchParams.get("FilterData") || "[]";
          search = searchParams.get("search") || JSON.stringify("");
        }
      } catch {}
      const url = `activeTab=${JSON.stringify(targetTab)}&search=${search}`;
      navigate(`/explore?${window.btoa(url)}`);
    }, [activeExploreTab, location.pathname, location.search, navigate]);

  const isExploreRoute = React.useMemo(()=>location.pathname === "/explore",[location.pathname]);

  return (
    <>
      {location.pathname === "/" ? null : (
      <AppBar
        position="sticky"
        sx={{
          top: 0,
          "&.MuiAppBar-root ": {
            backgroundColor: "#fff",
            px: { xs: 0, sm: 5 },
            boxShadow: "0 2px 2px #3f5c6e26",
          },
        }}
      >
        <Container maxWidth="xl">
          <Toolbar
            disableGutters
            sx={{ justifyContent: "space-between", alignItems: "center" }}
          >
            <Box
              component="img"
              src={Images.oneWindow}
              alt="logo"
              onClick={() => navigate("/dashboard")}
              sx={{ display: {}, mr: 1, width: "150px", cursor: "pointer" }}
            />
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: "20px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  height: "50px",
                  gap: "20px",
                }}
              >
                <Search
                  appliedFilter={props.appliedFilter}
                  setAppliedFilter={props.setAppliedFilter}
                  setAnchorElNav={setAnchorElNav}
                />
                <Typography sx={{ cursor: "pointer", fontSize: "1.1rem", fontWeight: location.pathname.startsWith("/explore") ?"600":"500", color: location.pathname.startsWith("/explore") ? "#3b3f76" : "#000" }} onClick={() => navigate("/explore")}>Explore</Typography>
                <img
                  className="user-info img"
                  style={{
                    borderRadius: "50%",
                    height: "50px",
                    width: "50px",
                  }}
                  src={profile.data?.displayPicSrc ? profile?.data?.displayPicSrc : "https://res.cloudinary.com/dffdp7skh/image/upload/v1706879929/nvitahnrlhvmtcizpthx.png"}
                  alt="User Profile"
                />
                <Typography sx={{ color: "#000", fontWeight: "600" }}>
                  Welcome back, {profile?.data?.firstName} !
                </Typography>
              </Box>
              {
                  isExploreRoute && (
                    <Box className="header-signin-desktop" sx={{ flexDirection: "row", gap: "1rem", px: '10px' }} >
                      {activeExploreTab && (
                        <Button
                          onClick={handleExploreListToggle}
                          sx={[globalButton, {
                            fontSize: '15px',
                            px: "15px",
                            background:"#70A6B2",
                            "&:hover": {
                              backgroundColor: "#70A6B2",
                              color: "#fff",
                            },
                          }]}
                        >
                          {activeExploreTab === "courses" ? "Universities" : "Courses"}
                        </Button>
                      )}
                    </Box>
                  )
              }
              <Button
                variant="contained"
                onClick={() => {
                  localStorage.clear();
                  logOut();
                  navigate("/");
                }}
              >
                Logout
              </Button>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
    )} 
    </>
  );
};

export default Header;
